import { Center, ChakraProps, Spinner } from "@chakra-ui/react";

export function PageSpinner({ bg, color }: ChakraProps) {
  return (
    <Center bg={bg} position={"fixed"} top={0} bottom={0} left={0} right={0} zIndex={1000}>
      <Spinner color={color?.toString()} size={"xl"} />
    </Center>
  );
}
